/* My Kid's Dream - live book preview, part 3: loading, rendering, init.
 * Reader: an open book. The cover shows as the front cover only (right half
 * of page 1, which is a two-cover spread image) sitting on the right; every
 * turn is a 3D page flip. Neighboring spreads are pre-rendered into a bitmap
 * cache so turns are instant. */
window.MKDP = window.MKDP || {};
MKDP.PDFJS_SRC = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js';
MKDP.PDFJS_WORKER = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
MKDP.fetchOriginal = function (onProgress) {
  var state = MKDP.state;
  if (state.origBytes) return Promise.resolve(state.origBytes);
  if (state.fetching) return state.fetching;
  state.fetching = fetch(state.config.pdfUrl).then(function (resp) {
    var total = parseInt(resp.headers.get('Content-Length') || '0', 10);
    var reader = resp.body.getReader(), chunks = [], loaded = 0;
    function read() {
      return reader.read().then(function (res) {
        if (res.done) return;
        chunks.push(res.value); loaded += res.value.length;
        if (onProgress && total) onProgress(loaded / total);
        return read();
      });
    }
    return read().then(function () {
      var all = new Uint8Array(loaded), off = 0;
      chunks.forEach(function (c) { all.set(c, off); off += c.length; });
      state.origBytes = all;
      return all;
    });
  });
  return state.fetching;
};
MKDP.loadPdfjs = function () {
  var state = MKDP.state;
  if (state.pdfjs) return Promise.resolve(state.pdfjs);
  if (window.pdfjsLib) {
    window.pdfjsLib.GlobalWorkerOptions.workerSrc = MKDP.PDFJS_WORKER;
    state.pdfjs = window.pdfjsLib;
    return Promise.resolve(state.pdfjs);
  }
  return new Promise(function (resolve, reject) {
    var s = document.createElement('script');
    s.src = MKDP.PDFJS_SRC;
    s.onload = function () {
      if (!window.pdfjsLib) { reject(new Error('pdf engine loaded without a library handle')); return; }
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = MKDP.PDFJS_WORKER;
      state.pdfjs = window.pdfjsLib;
      resolve(state.pdfjs);
    };
    s.onerror = function () { reject(new Error('pdf engine script failed to load')); };
    document.head.appendChild(s);
  });
};
MKDP.trail = [];
MKDP.mark = function (s) { MKDP.trail.push(s); if (MKDP.trail.length > 8) MKDP.trail.shift(); };
MKDP.isBenign = function (err) {
  if (!err) return true;
  if (err.name === 'RenderingCancelledException') return true;
  return /same canvas|multiple render/i.test(err.message || '');
};
MKDP.fail = function (err) {
  if (MKDP.isBenign(err)) return;
  var els = MKDP.els;
  MKDP.setLoading(false);
  if (els.status) {
    els.status.hidden = false;
    els.status.textContent = 'The preview hit a snag (' + MKDP.trail.join(' > ') + '): ' +
      (err && err.name ? err.name + ': ' : '') + (err && err.message ? err.message : String(err));
  }
};
MKDP.getDoc = function (name, onProgress) {
  var state = MKDP.state;
  var key = name || state.config.sampleName;
  if (state.cache[key]) return Promise.resolve(state.cache[key]);
  MKDP.mark('fetch+engine');
  return Promise.all([MKDP.fetchOriginal(onProgress), MKDP.loadPdfjs()]).then(function (res) {
    var bytes = res[0], lib = res[1];
    MKDP.mark('got ' + bytes.length + ' bytes');
    var prep = (!name || name === state.config.sampleName)
      ? Promise.resolve({ bytes: bytes, titlePatched: true })
      : MKDP.patchPdf(bytes, state.config.sampleName, name, state.config.titleCodes);
    return prep.then(function (patched) {
      MKDP.mark('open doc');
      return lib.getDocument({ data: patched.bytes.slice() }).promise.then(function (doc) {
        MKDP.mark('doc ' + doc.numPages + ' pages');
        var entry = { doc: doc, titlePatched: patched.titlePatched };
        state.cache[key] = entry;
        return entry;
      });
    });
  });
};

MKDP.nameInputSelector = 'input[name="properties[First Name of the person in the book:]"]';
MKDP.applyName = function (raw, fromOverlay) {
  var state = MKDP.state, els = MKDP.els;
  var name = MKDP.sanitizeName(raw);
  var formInput = document.querySelector(MKDP.nameInputSelector);
  if (!fromOverlay && formInput) name = MKDP.sanitizeName(formInput.value);
  if (fromOverlay && formInput && formInput.value !== name) formInput.value = name;
  if (!fromOverlay) els.input.value = name;
  if (name && MKDP.buyHint) MKDP.buyHint(''); // a typed name retires the empty-name hint
  var target = name || state.config.sampleName;
  if (target === state.docName && state.doc) return;
  MKDP.setLoading(true, null, name ? 'Putting ' + name + ' in the book\u2026' : 'Preparing the real book\u2026');
  MKDP.getDoc(name).then(function (entry) {
    state.doc = entry.doc;
    state.docName = target;
    MKDP.clearBitmaps();
    els.note.hidden = entry.titlePatched || !name;
    state.page = Math.min(state.page, entry.doc.numPages);
    MKDP.renderView();
  }).catch(function (err) {
    MKDP.getDoc('').then(function (entry) {
      state.doc = entry.doc; state.docName = state.config.sampleName;
      MKDP.clearBitmaps();
      MKDP.renderView();
    }).catch(function () { MKDP.fail(err); });
  });
};
MKDP.overlayBuilt = false;
MKDP.openOverlay = function () {
  var state = MKDP.state, els = MKDP.els;
  if (!MKDP.overlayBuilt) { MKDP.buildOverlay(); MKDP.overlayBuilt = true; }
  var h1 = document.querySelector('.product__title h1');
  els.title.textContent = (h1 && h1.textContent.trim()) ? h1.textContent.trim() : document.title.split('\u2013')[0].trim();
  if (MKDP.initBuy) MKDP.initBuy();
  els.overlay.hidden = false;
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  var formInput = document.querySelector(MKDP.nameInputSelector);
  els.input.value = formInput ? formInput.value : '';
  state.page = 1;
  MKDP.resetZoom();
  if (state.doc) MKDP.renderView();
  else {
    MKDP.setLoading(true, 0, 'Preparing the real book\u2026');
    MKDP.fetchOriginal(function (frac) {
      if (!state.doc) MKDP.setLoading(true, frac, 'Preparing the real book\u2026');
    }).catch(function () {});
    MKDP.applyName(els.input.value, true);
  }
};
MKDP.initPreview = function () {
  var slot = document.querySelector('[data-mkd-preview-slot]');
  if (!slot) return;
  var handle = slot.getAttribute('data-handle');
  var config = MKDP.BOOKS[handle];
  if (!config) { slot.remove(); return; }
  MKDP.state.config = config;
  MKDP.injectCss();
  if (MKDP.initSticky) MKDP.initSticky();
  var wrap = document.createElement('div');
  wrap.className = 'mkd-slot';
  if (config.personalize) {
    wrap.innerHTML = '<button type="button" class="mkd-open mkd-open-primary">Personalize my book</button>';
  } else {
    wrap.innerHTML = '<button type="button" class="mkd-open">\uD83D\uDCD6 Preview the whole book</button>' +
      '<p class="mkd-open-sub">Free \u00B7 See all ' + config.pages + ' pages with their name in the story</p>';
  }
  slot.appendChild(wrap);
  wrap.querySelector('.mkd-open').addEventListener('click', MKDP.openOverlay);
  if ('requestIdleCallback' in window) {
    requestIdleCallback(function () { MKDP.fetchOriginal(null).catch(function () {}); }, { timeout: 4000 });
  }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', MKDP.initPreview);
else MKDP.initPreview();

/* MKD component clicks: trust carousel nav, review read more, coupon copy. */
document.addEventListener('click', function (e) {
  if (!e.target.closest) return;
  var nav = e.target.closest('.tn');
  if (nav) { var tr = nav.parentElement.querySelector('.tt'); if (tr && tr.clientWidth) { var n = tr.children.length; var i = Math.round(tr.scrollLeft / tr.clientWidth) + (+nav.getAttribute('data-d')); i = ((i % n) + n) % n; tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); } return; }
  var tm = e.target.closest('.tm');
  if (tm) { var wrap = tm.closest('.tq'); if (wrap) { wrap.classList.toggle('op'); tm.textContent = wrap.classList.contains('op') ? 'Read less' : 'Read more'; } return; }
  var cp = e.target.closest('.cpb');
  if (cp) { if (navigator.clipboard) navigator.clipboard.writeText(cp.getAttribute('data-code') || ''); var s = cp.querySelector('.cpp'); if (s) { s.style.opacity = '1'; setTimeout(function () { s.style.opacity = '0'; }, 1500); } }
});

/* Trust carousel auto-advance with wrap-around; pauses while touched. */
(function () {
  if (window.__tcAuto) return; window.__tcAuto = 1;
  var holdUntil = 0;
  document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('.tc')) holdUntil = Date.now() + 6000; }, { passive: true });
  setInterval(function () {
    if (document.hidden || Date.now() < holdUntil) return;
    document.querySelectorAll('.tt').forEach(function (tr) {
      var r = tr.getBoundingClientRect();
      if (r.bottom < 0 || r.top > (window.innerHeight || 0)) return;
      var n = tr.children.length;
      if (n < 2 || !tr.clientWidth) return;
      var i = Math.round(tr.scrollLeft / tr.clientWidth) + 1;
      tr.scrollTo({ left: (i % n) * tr.clientWidth, behavior: 'smooth' });
    });
  }, 4200);
})();

/* Fixed Personalize bar: shown only while the inline button is off screen. */
(function () {
  if (window.__mkdBar) return; window.__mkdBar = 1;
  function drive() {
    var bar = document.querySelector('.mkd-stickybar');
    var slot = document.querySelector('[data-mkd-preview-slot]');
    if (!bar || !slot) return false;
    if (bar.parentElement !== document.body) document.body.appendChild(bar);
    bar.removeAttribute('hidden');
    var btn = bar.querySelector('.mkd-sticky-btn');
    if (btn && !btn.__mkdWired) { btn.__mkdWired = 1; btn.addEventListener('click', function () { if (MKDP.openOverlay) MKDP.openOverlay(); }); }
    function sync() {
      var open = document.querySelector('.mkd-open');
      if (!open) { bar.setAttribute('data-on', '0'); return; }
      var r = open.getBoundingClientRect();
      var visible = r.bottom > 0 && r.top < (window.innerHeight || 0);
      bar.setAttribute('data-on', visible ? '0' : '1');
    }
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    setInterval(sync, 500);
    sync();
    return true;
  }
  if (!drive()) { var iv = setInterval(function () { if (drive()) clearInterval(iv); }, 400); setTimeout(function () { clearInterval(iv); }, 8000); }
})();
